import { IStepLocation } from 'src/types'

export function findLocationsWithinGeofence(
  locations: IStepLocation[],
  centerPoint: { lat: number; lng: number },
): IStepLocation[] {
  // Convert degrees to radians
  const degreesToRadians = (degrees: number) => (degrees * Math.PI) / 180

  const earthRadiusMetres = 6371000 // Earth's radius in metres

  // Function to determine if a single location is within the geofence
  const isWithinGeofence = (location: IStepLocation) => {
    const checkPointLatRad = degreesToRadians(location.lat)
    const checkPointLngRad = degreesToRadians(location.lng)
    const centerPointLatRad = degreesToRadians(centerPoint.lat)
    const centerPointLngRad = degreesToRadians(centerPoint.lng)

    // Calculate the differences in radians
    const latDiffRad = checkPointLatRad - centerPointLatRad
    const lngDiffRad = checkPointLngRad - centerPointLngRad

    // Haversine formula to calculate the distance
    const a =
      Math.sin(latDiffRad / 2) ** 2 +
      Math.cos(centerPointLatRad) * Math.cos(checkPointLatRad) * Math.sin(lngDiffRad / 2) ** 2
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    const distanceMetres = earthRadiusMetres * c

    // Return true if the distance is within the radius
    return distanceMetres <= location.radius
  }

  // Filter locations based on the geofence check
  return locations.filter((item) => isWithinGeofence(item))
}
